<template>
  <b-card class="d-inline-block" bg-variant="lighter">
    <div class="d-inline-block px-3">
      <cool-label>Publisher Name</cool-label>
      <h5>{{ details.name }}</h5>
    </div>
    <div class="d-inline-block px-3">
      <cool-label>Domain</cool-label>
      <h5>{{ details.domain }}</h5>
    </div>
    <div class="d-inline-block px-3">
      <cool-label>Category</cool-label>
      <div>
        <span v-for="cat in details.cats" :key="cat">
          <span class="rounded-pill">
            {{ cats[cat] }}
          </span>
        </span>
      </div>
    </div>
  </b-card>
</template>

<style scoped>
.rounded-pill {
  background: var(--white);
  border: 2px solid var(--border);
  padding: 0.25em 0.75em;
  border-radius: 2em;
  margin: 0 0.25em;
  display: inline-block;
}
</style>

<script>
import iab from '@/assets/iab'
import auth from '@/auth'

export default {
  data () {
    return {
      cats: iab,
    }
  },
  props: {
    details: { required: true, type: Object }
  }
}
</script>



// WEBPACK FOOTER //
// src/publisher/components/PublisherDetailsCard.vue